import FileSaver from "file-saver";
import VueThat from "@/main";
import { Loading } from 'element-ui';

export function download(url, params, fileName) {
  // downloadLoadingInstance = ElLoading.service({ text: "正在下载数据，请稍候", background: "rgba(0, 0, 0, 0.7)" });
  const loadingInstance = Loading.service({ fullscreen: true });
  VueThat.$http
    .get(global.apiUrl + url + "?" + tansParams(params), {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      },
      responseType: "blob"
    })
    .then(async (resp) => {
      loadingInstance.close();
      const contentDispostion = decodeURIComponent(resp.headers.map["content-disposition"]);
      const fileRegex = /filename=.*/g;
      const result = contentDispostion.match(fileRegex);
      let respFileName = "";
      let type = "";
      // 获取响应文件的文件名
      if (result && result.length > 0) {
        respFileName = result[0].replace("filename=", "").replace(";", "");
        const arr = respFileName.split(".");
        type = arr[arr.length - 1];
      }

      var now = new Date();
      respFileName = `${fileName || "导出表格"}_${now.getTime()}.${type}`;

      const errorCode = {
        401: '认证失败，无法访问系统资源',
        403: '当前操作没有权限',
        404: '访问资源不存在',
        default: '系统未知错误，请反馈给管理员'
      }

      const data = resp.data;
      const isblob = blobValidate(data);
      if (isblob) {
        const blob = new Blob([data]);
        FileSaver.saveAs(blob, respFileName);
      } else {
        const resText = await data.text();
        const rspObj = JSON.parse(resText);
        const errMsg = errorCode[rspObj.code] || rspObj.msg || errorCode.default;
        VueThat.$message.error(errMsg);
      }
    })
    .catch((r) => {
      loadingInstance.close();
      console.error(r);
      VueThat.$message.error("下载文件出现错误，请联系管理员！");
    });
}

// 验证是否为blob格式
const blobValidate = (data) => {
  return data.type !== 'application/json';
};

/**
 * 参数处理
 * @param {*} params  参数
 */
const tansParams = (params) => {
  let result = '';
  for (const propName of Object.keys(params)) {
    const value = params[propName];
    const part = encodeURIComponent(propName) + '=';
    if (value !== null && value !== '' && typeof value !== 'undefined') {
      if (typeof value === 'object') {
        for (const key of Object.keys(value)) {
          if (value[key] !== null && value[key] !== '' && typeof value[key] !== 'undefined') {
            const params = propName + '[' + key + ']';
            const subPart = encodeURIComponent(params) + '=';
            result += subPart + encodeURIComponent(value[key]) + '&';
          }
        }
      } else {
        result += part + encodeURIComponent(value) + '&';
      }
    }
  }

  return result;
};
